{
  "loading": "Завантаження…",
  "placeholder": "Виберіть опцію..."
}
